
/* eslint-disable */
import React, { Component } from 'react';
import cx from 'classnames';
import { getParams, addUrlParam } from '../utils/util';

import './OzTabs.css'


class OzTabs extends Component {
  state = {}

  constructor(props) {
    super(props);
    let params = getParams();
    if (params.tab) {
      this.state = { active: params.tab };
    }
    console.log('tab??', props, props.tab);
    if (props.tab) {
      this.state = { active: props.tab };
    }
  }

  switchTab(tabKey) {
    this.setState({ active: tabKey });
    if (!this.props.noUrl) {
      addUrlParam({ tab: tabKey });
    }
  }

  render() {
    let nonNull = [];
    for (let c of this.props.children) {
      if (c) nonNull.push(c);
    }

    let children = Array.isArray(nonNull) ? nonNull : [nonNull];

    let active = children[0];
    if (this.state.active) {
      for (let child of children) {
        if (child.props.tabKey == this.state.active) {
          active = child;
        }
      }
    }

    let tabNodes = children.map(child => {
      let tabKey = child.props.tabKey;
      let tabName = child.props.tabName;
      return (
        <div
          key={tabKey}
          onClick={() => this.switchTab(tabKey)}
          className={cx('oz-tab-choice', { active: active.props.tabKey == tabKey })}
        >
          {tabName}
        </div>
      )
    });

    return (
      <div className="OzTabs">
        <div className="oz-tab-switcher">
          <div className="spacer"></div>
          {tabNodes}
          <div className="spacer"></div>
        </div>
        {this.props.header}
        <div className="oz-tab-content">{active}</div>
      </div>
    );
  }
}

export default OzTabs;



/** WEBPACK FOOTER **
 ** ./src/lib/OzTabs.js
 **/